export const AVAILABLE_CURRENCIES = [
  {
    value: "AUD",
    image: "https://flagicons.lipis.dev/flags/4x3/au.svg",
  },
  {
    value: "USD",
    image: "https://flagicons.lipis.dev/flags/4x3/us.svg",
  },
  {
    value: "CAD",
    image: "https://flagicons.lipis.dev/flags/4x3/ca.svg",
  },
  {
    value: "GBP",
    image: "https://flagicons.lipis.dev/flags/4x3/gb.svg",
  },
  {
    value: "NZD",
    image: "https://flagicons.lipis.dev/flags/4x3/nz.svg",
  },
  {
    value: "EUR",
    image: "https://flagicons.lipis.dev/flags/4x3/eu.svg",
  },
];
